module.exports = "/_next/static/images/avatar-frame-tier-3-14cc4141c7f9585bbee90ba5391486a6.png";